import { Sitters } from './sitters';


/**
 * class responsibility to deal with app validation
 */
export class SittersValidation extends Sitters {
    constructor(config) {
        super(config);
    }

    /**
     * build object with which mode app working
     * @returns 
     */
    sittersAppMode() {
        return {
            isGoogleMode: this._sitterCheckProperty(this._config, ['guid', 'isEditable', 'mapDivId', 'clientId', 'exportIncubatorToGoogle']),
            isSittersRenewer: this.isSittersRenewer(),
            isEditeMode: this.isEditMode(),
            isSitterPortPaths: this.sitterPortPaths(),
            isSellingPortType: this.sellingPortType(),
            isSitterId: this.sitterIdCheck()
        }
    }

    /**
     * check if app is editable true
     * @returns 
     */
    isEditMode() {
        if (this._sitterCheckProperty(this._config, ['guid', 'isEditable', 'mapDivId'])) {
            if (this._config.isEditable == true && this._config.guid.length > 0) return true;
        }
        return false;
    }

    /**
     * check SellingPortType property
    */
    sitterPortPaths() {
        if (this._sitterCheckProperty(this._config, ['sitterPortPaths'])) {
            if (this._config.sitterPortPaths.length > 0) return true;
        }
        return false;
    }


    /**
     * check sellingPortType property
    */
    sellingPortType() {
        if (this._sitterCheckProperty(this._config, ['sellingPortType'])) {
            if (this._config.sellingPortType == true) {
                return true;
            }
        }
        return false;
    }

    /**
     * check if sitterId exist
     */
    sitterIdCheck() {
        if (this._sitterCheckProperty(this._config, ['sitterId'])) {
            if (this._config.sitterId.length > 0) {
                return true;
            }
        }
        return false;
    }

    /**
     * check if renewer mode
     * @returns 
     */
    isSittersRenewer() {
        if (this._sitterCheckProperty(this._config, ['guid', 'isEditable', 'mapDivId', 'clientId'])) {
            if ('exportIncubatorToGoogle' in this._config && this._config.exportIncubatorToGoogle == false)
                return true;
            else if ('exportIncubatorToGoogle' in this._config )
                return false;

            if (!('exportIncubatorToGoogle' in this._config) && this._config.isEditable == false) return true;
        }
        return false;
    }

    _sitterCheckProperty(arrayItems, selectedArrayProperty) {
        return selectedArrayProperty.every(arrItem => Object.keys(arrayItems).includes(arrItem));
    }
}